import React from "react";
import Grid from "@material-ui/core/Grid";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import ContextMenu from "../../../components/contextMenu";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import {Divider} from "@material-ui/core";
import {Button} from "primereact/button";

const EventsReportView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={8}>
                        <TitlePage title="Reportes \ Reporte de Eventos"/>
                    </Grid>
                    <Grid item xs={4} style={{textAlign: 'right'}}>
                        <Button type="button" iconPos="left" label="Buscar"
                                style={{marginRight: '.5em'}} onClick={props.getDataReport}
                                disabled={props.disabledSearchButton}
                        />
                    </Grid>
                    <Grid item xs={12}> <Divider/> </Grid>
                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <ContextMenu menuOptions={props.exportOptions}
                                     isButton={true}
                                     label="Exportar"/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            value={props.dataReport}
                            scrollable={true}
                            expandedRows={props.expandedRows}
                            rowExpansionTemplate={props.rowExpansionTemplate}
                            style={{width: '100%'}}
                            resizableColumns={true}
                            columnResizeMode={"fit"}
                            scrollHeight="600px">
                            {props.columns}
                        </DataTable>
                    </Grid>
                    {props.confMsg}
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default EventsReportView;